import { useEffect } from 'react'

export const useDocumentTitleEffect = (title?: string) =>
  useEffect((): void => {
    if (title !== undefined) document.title = title
  }, [title])
